import { MutationTree } from 'vuex';
import { DomainState, Domain } from './domain-types';

export const mutations: MutationTree<DomainState> = {
  setDomainInState(state, payload: Domain) {
    state.error = false;
    state.domain = payload;
  },
  profileError(state) {
    state.error = true;
    state.domain = undefined;
  },
};
